module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesUrban@2x.9687a5c.jpg";